export default __webpack_public_path__ + "static/community-f17f2288ea01746f55473054fee56c71.svg";